$(document).ready(function () {
  YouTubePlayer._init();

  // jQuery.validator.setDefaults({
  //   debug: true,
  //   success: "valid"
  // });

  inView('.js-animate')
    .on('enter', el => {
      $(el).addClass("css-animate");
    });

  $(".contact form").validate({
    rules: {
      name: {
        required: true,
        minlength: 3
      },
      tel: {
        required: true,
        minlength: 9
      },
      email: {
        required: true,
        email: true,
        minlength: 3
      },
      msg: {
        required: true,
      }
    }
  });

  $(".product__calculator_form").validate({
    rules: {
      width: {
        required: true,
        min: 0,
        number: true
      },
      height: {
        required: true,
        min: 0,
        number: true
      },
      count: {
        required: true,
        min: 0,
        number: true
      }
    }
  });

  $(".arrow-top").click(function(){
    $("html, body").animate({ scrollTop: 0 }, "slow");
    return false;
  });
  $(".header__mobile_menu, .close_menu").click(function () {
    $(".mobileMenu").toggleClass("active");
  });
  $(".openSubMenu").click(function() {
    $(this).parent().find("ul").toggleClass("active");
  });
  $(".back").click(function() {
    $("ul").removeClass("active");
  });

  $(window).scroll(function(){
    if ($(window).scrollTop() > 0) {
      $(".header").addClass('fixed');
    } else {
      $(".header").removeClass('fixed');
    }
    if ($(window).scrollTop() > 300 ) {
      $(".arrow-top").addClass('active');
    } else {
      $(".arrow-top").removeClass('active');
    }
  });

  let owlBanner = $('.banner__wrapper');
  owlBanner.owlCarousel({
    loop: true,
    margin: 0,
    items: 1,
    animateOut: 'fadeOut',
    animateIn: 'fadeIn',
    touchDrag: false,
    mouseDrag: false,
    autoplay: false,
    autoplayTimeout: 7e3,
    smartSpeed: 1e3,
    dots: true,
    onRefreshed:function(el){
      $('.banner__wrapper').find(".banner__item_text").removeClass("css-animation");
      $('.banner__wrapper').find(".owl-item.active").find(".banner__item_text").addClass("css-animation");
    },
    onInitialized:function(el){

    },
    onChanged:function(el){
      setTimeout(function() {
        $('.banner__wrapper').find(".banner__item_text").removeClass("css-animation");
        $('.banner__wrapper').find(".owl-item.active").find(".banner__item_text").addClass("css-animation");
      }, 1000);
    }
  });
  $('.banner__nav_item-prev').click(function(){
    owlBanner.trigger('prev.owl.carousel');
  });
  $('.banner__nav_item-next').click(function(){
    owlBanner.trigger('next.owl.carousel');
  });

  $('.content__video_slider').slick({
    prevArrow: $('.content__video_nav-item-prev'),
    nextArrow: $('.content__video_nav-item-next'),
    slidesToShow: 2,
    slidesToScroll: 2,
    centerMode: false,
    swipe: true,
    vertical: true,
    dots: false,
    infinite: true
  });
  $(".content__video_slider-item").bind("click", function () {
    let videoId = $(this).data("videoid");
    YouTubePlayer.changeVideo(videoId);
  });

  $(".js-scroll").stick_in_parent({ offset_top: getStickInParentPx() });

  $('.contact__button_inner').click((e) => {
    e.preventDefault();
    $([document.documentElement, document.body]).animate({
      scrollTop: $(".contact__form").offset().top
  }, 2000);
  });

  // $('.contact-map__point').click(function (e) {
  //   $('.contact-map__place_town').text($(this).data('name'));
  //   $('.contact-map__place_body b').text($(this).data('title'));
  //   $('.contact-map__place_body p').text($(this).data('address'));
  // });

  function getStickInParentPx () {
    const offsetTop = 7.25;

    return offsetTop * document.documentElement.clientWidth / 100;
  }
  $('.content__gallery, .gallerySlider__wrapper, .product__information_slider').magnificPopup({
    delegate: 'a.openPhoto',
    type: 'image',
    tLoading: 'Ładowanie #%curr%...',
    mainClass: 'mfp-with-zoom',
    tClose: 'Zamknij',
    removalDelay: 400,
    gallery: {
      enabled: true,
      navigateByImgClick: true,
      tPrev: 'Poprzednie',
      tNext: 'Następne',
      preload: [0, 1], // Will preload 0 - before current, and 1 after the current image
      tCounter: '<span class="mfp-counter">%curr% z %total%</span>'
    },
    image: {
      tError: '<a href="%url%">Zdjęcie #%curr%</a> nie może być załadowane.',
      titleSrc: function (item) {
        return item.el.attr('title');
      }
    }
  });
});

$('.js-select').select2({
  minimumResultsForSearch: -1
});

var myCookie = Cookies.get('cookies_info');
if (myCookie === undefined) {
  $('.rodo').show();
}
function closeRodoModalAndSaveCookie () {
  $('.rodo').fadeOut();
  Cookies.set('cookies_info', '1', {expires: 12});
}

function onYouTubeIframeAPIReady() {
  if ($(".content__video_slider").length > 0 && $(".content__video_slider-item").length > 0) {
    $('.content__video_slider-item')[0].click();
  }
}

let YouTubePlayer = (function () {
  let player;

  return {
    _init: function () {
      const tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      const firstScriptTag = document.getElementsByTagName('script')[0];
      firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    },
    changeVideo: function (videoId) {
      $('.content__video_left').html('<div id="player" class="content__video_player"></div>');
      player = new YT.Player('player', {
        height: '100%',
        width: '100%',
        videoId: videoId,
        playerVars: {
          showinfo: 0,
          rel: 0
        },
      });
    }
  }
}());
